// extracted by mini-css-extract-plugin
export default {"select":"styles_select__UXiq5","withValue":"styles_withValue__tvOsA","inline":"styles_inline__-dQzm"};